import reportContextManager from '../../managers/reports/ReportContextManager';
import reportTableManager from '../../managers/reports/ReportTableManager';

import ReportIdentityService from './ReportIdentityService';
import ReportTableService from './ReportTableService';

export default class ReportContextService {
  /** @param {import('../../managers/reports/ReportContextManager').ReportContextType} reportContextType */
  static switchReportContext = (reportContextType) => {
    if (ReportIdentityService.isReportStandardsClassroomDetailStudents()) {
      reportContextManager.setReportStandardsClassroomDetailStudentsContextType(reportContextType);
      reportTableManager.setShouldReinitializeReportTableExpandedRows(true);
      ReportTableService.forceRerenderReportTable();
    } else {
      reportContextManager.setReportContextType(reportContextType);
      reportTableManager.setShouldReinitializeReportTableExpandedRows(true);
      ReportTableService.forceRerenderReportTable();
    }
  }
}
